// extracted by mini-css-extract-plugin
export default {"quotaWarningContainer":"ozoQKPMrNomRmi39Silb","quotaWarning":"HyvlFduh5lSD0fCNE6Tg","quotaWarningIcon":"gf4Z_fXN9oZ_mkg5yOGH"};